import { render } from "./prime-recommendations.vue?vue&type=template&id=4c9d996e&scoped=true"
import script from "./prime-recommendations.vue?vue&type=script&lang=js"
export * from "./prime-recommendations.vue?vue&type=script&lang=js"

import "./prime-recommendations.vue?vue&type=style&index=0&id=4c9d996e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9d996e"]])

export default __exports__